import React, { useState } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";

import { Avatar, Button, IconButton, Typography } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import { Row, Col, Input } from "reactstrap";
import ArchiveIcon from "@material-ui/icons/Archive";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ReplayIcon from "@material-ui/icons/Replay";
/* import ConfirmModal from '../../../cms/components/ConfirmModal/ConfirmModal'; */
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import SystemLabel from "../../system/SystemLabel/SystemLabel";
import BlockIcon from "@material-ui/icons/Block";
import RestoreIcon from "@material-ui/icons/Restore";
import ForumIcon from "@material-ui/icons/Forum";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";

const wrapperStyle = {
  width: "100%",
  height: "100vh",
  display: "inline-flex",
};
const listCol = {
  width: "20%",
  height: "100%",
  backgroundColor: "#222",
  zIndex: 1,
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0), 0 2px 4px rgba(0, 0, 0, 0), 0 4px 8px rgba(0, 0, 0, 0), 0 4px 4px rgba(0, 0, 0, 0), 0 4px 4px rgba(0, 0, 0, 0), 0 20px 20px rgba(0, 0, 0, 0.3) !important",
};
const messageCol = {
  width: "80%",
  height: "100%",
  paddingLeft: "20px",
  backgroundColor: "#1d1d1d",
};
const questionHeaderStyle = {
  padding: "20px",
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0), 0 2px 4px rgba(0, 0, 0, 0), 0 4px 8px rgba(0, 0, 0, 0), 0 4px 4px rgba(0, 0, 0, 0), 0 4px 4px rgba(0, 0, 0, 0), 0 20px 20px rgba(0, 0, 0, 0.3) !important",
  /*     borderBottom: '1px solid gainsboro' */
};
const listStyle = {
  maxHeigth: "100%",
  overflowY: "auto",
  maxHeight: "calc(100vh - 73px)",
  minHeight: "calc(100vh - 73px)",
};

export default class ChatMessageList extends React.Component {
  state = {
    selectedChat: null,
    confirmDialog: false,
    stamp: [],
    messagesToShow: 30,
    enableScroll: false,
    editId: null,
  };

  toggleChat = (c) => {
    const { selectedChat } = this.state;
    if (selectedChat && c.eventId === selectedChat.eventId) {
      this.setState({ selectedChat: null });
    } else {
      this.setState({ selectedChat: c });
    }
  };
  componentDidUpdate(prevProps, prevState) {
    const { chatMessages } = this.props;
    if ((!prevState.selectedChat && this.state.selectedChat) || (prevState.selectedChat && this.state.selectedChat && prevState.selectedChat.eventId != this.state.selectedChat.eventId)) {
      this.handleScroll();
    }
    if (this.props.scroll && !prevProps.scroll) {
      this.handleScroll();
      this.setState({ messagesToShow: this.state.messagesToShow + 1 });
    }
  }
  componentDidMount() {
    this.handleScroll();
    this.scrollRef = React.createRef();
  }

  onScroll = (manual = false) => {
    if (this.state.enableScroll) {
      const { chatMessages } = this.props;
      const { initalScrollPos, messagesToShow } = this.state;
      const scrollTop = this.scrollRef.current.scrollTop;
      if (scrollTop < 3 && this.state.selectedChat) {
        const resChat = chatMessages.find((c) => c.eventId == this.state.selectedChat.eventId);
        if (resChat) {
          let index = chatMessages.indexOf(resChat);
          if (index > -1) {
            let maxMessages = chatMessages[index].messages.length;
            if (messagesToShow < maxMessages + 20) {
              this.setState({ messagesToShow: messagesToShow + 1 });
              this.scrollRef.current.scrollTop = 6;
            }
          }
        }
      }
      if (scrollTop > 15) {
        if (messagesToShow > 30) {
          this.setState({ messagesToShow: messagesToShow - 1 });
          this.scrollRef.current.scrollTop = 14;
        }
      }
    }
  };

  handleScroll = (id) => {
    if (this.state.selectedChat) {
      const { chatMessages } = this.props;
      const { messagesToShow } = this.state;
      const index = chatMessages.indexOf(this.state.selectedChat);
      if (index > -1 && chatMessages[index].messages.length > 0) {
        let pos = chatMessages[index].messages.slice(messagesToShow * -1).length - 1;
        if (pos > 0 && this.refs[index] !== undefined) {
          try {
            this.refs[pos].scrollIntoView({ block: "end", behavior: "smooth" });
            setTimeout(() => this.setState({ enableScroll: true }), 1500);
          } catch (error) {
            console.error(error);
          }
        }
      }
    }
  };

  onSaveEdit = (text) => {
    this.props.onEditMessage(this.state.editId, text);
    this.setState({ editId: null });
  };

  render() {
    const { responses, questions, chatMessages, lang, onRemoveMessage, block = () => null } = this.props;
    const { selectedChat } = this.state;

    return (
      <div style={wrapperStyle}>
        <div style={listCol} className="stage-list">
          <div style={questionHeaderStyle}>
            <Typography className="primary-text" style={{ fontSize: "1.4rem" }}>
              {" "}
              <SystemLabel name="Chats" languageCode={lang} />
            </Typography>
          </div>
          <List style={listStyle} component="nav" className="dark-list">
            {chatMessages.length > 0
              ? chatMessages.map((q, i) => {
                  return (
                    <React.Fragment>
                      <ListItem
                        onClick={() => this.toggleChat(q)}
                        style={{
                          listStyle: "none",
                          display: "flex",
                          cursor: "pointer",
                          backgroundColor: this.state.selectedChat && this.state.selectedChat.eventId == q.eventId ? "#2098c2" : undefined,
                        }}
                        key={i}
                      >
                        <ListItemAvatar className="">
                          <ForumIcon style={{ color: "#eee" }} />
                        </ListItemAvatar>
                        <ListItemText className="primary-text" style={{ maxWidth: "65%" }} primary={q.eventName} />
                        <ListItemSecondaryAction>
                          <IconButton style={{ color: "rgba(238, 238, 238, 0.37)" }} onClick={() => this.toggleChat(q)}>
                            <ChevronRightIcon />
                          </IconButton>
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </React.Fragment>
                  );
                })
              : null}
          </List>
        </div>
        <div style={messageCol} className="stage-questions">
          <div style={{ ...questionHeaderStyle, display: "inline-flex" }}>
            <Typography className="primary-text" style={{ fontSize: "1.4rem", marginRight: 15 }}>
              {selectedChat ? selectedChat.eventName : <SystemLabel name="NoChatSelected" groupName={"Interaction.ChatModerator"} languageCode={this.props.lang} />}
            </Typography>
            {this.state.selectedChat && chatMessages.find((c) => c.eventId == this.state.selectedChat?.eventId)?.messages?.some((m) => m.hidden === true) && (
              <Button onClick={() => this.props?.exposeMessages(this.state.selectedChat?.eventId)} style={{ color: "#fff" }}>
                <SystemLabel name="ShowHiddenMessages" />
              </Button>
            )}
          </div>
          <div className="stage-conversation dark-list" ref={this.scrollRef} onScroll={() => this.onScroll(true)}>
            {this.state.selectedChat
              ? chatMessages.find((c) => c.eventId == this.state.selectedChat.eventId) &&
                chatMessages
                  .find((c) => c.eventId == this.state.selectedChat.eventId)
                  .messages.slice(this.state.messagesToShow * -1)
                  .map((m, i) => {
                    return (
                      <div ref={i} key={i} className="c-box" style={{ borderBottom: "1px solid #585858" }}>
                        <MessageBox
                          message={m.message}
                          no={i + 1}
                          timeStamp={m.inserted}
                          clientKey={m.sender}
                          lang={this.props.lang}
                          name={
                            m.senderFirstName ? (
                              `${m.senderFirstName} ${m.senderLastName} - ${m.senderCompanyName} - `
                            ) : m.sender.startsWith("sneakyspy") ? (
                              <React.Fragment>
                                <SystemLabel name="Moderator" />
                                {" - "}
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <SystemLabel name="Guest" />
                                {" - "}
                              </React.Fragment>
                            )
                          }
                          toggleVisibility={onRemoveMessage}
                          block={(clientKey, b) => block(clientKey, b, m.eventId)}
                          setEdit={(editId) => this.setState({ editId })}
                          isBlocked={chatMessages.find((c) => c.eventId == selectedChat.eventId).blockedClients.includes(m.sender)}
                          deleted={m.message.includes("JX_ADMIN_REMOVED")}
                          activeEdit={this.state.editId == m.interactionChatId}
                          id={m.interactionChatId}
                        />
                      </div>
                    );
                  })
              : null}
          </div>
        </div>
        {this.state.editId ? (
          <EditTextDialog
            onSave={(text) => this.onSaveEdit(text)}
            message={chatMessages.find((c) => c.eventId == this.state.selectedChat.eventId).messages.find((m) => m.interactionChatId == this.state.editId).message}
            onCancel={() => this.setState({ editId: null })}
            {...this.props}
          />
        ) : null}
        {this.state.confirmDialog && this.state.target ? <ConfirmDialog onCancel={() => this.setState({ confirmDialog: false })} onAction={this.saveStatus} lang={this.props.lang} type={this.state.target.type} /> : null}
      </div>
    );
  }
}
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditTextDialog = ({ onCancel, onSave, lang, message }) => {
  const [modifiedText, setModifedText] = useState(message);
  return (
    <Dialog open={true} TransitionComponent={Transition} keepMounted onClose={() => null} aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
      <DialogTitle id="alert-dialog-slide-title">
        {" "}
        <SystemLabel name="EditMessage" languageCode={lang} />
      </DialogTitle>
      <DialogContent style={{ width: 400 }}>
        <DialogContentText id="alert-dialog-slide-description">
          <Input type="textarea" style={{ minHeight: 450 }} value={modifiedText} defaultValue={message} onChange={(e) => setModifedText(e.target.value)} />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="primary">
          <SystemLabel languageCode={lang} name="Cancel" />
        </Button>
        <Button onClick={() => onSave(modifiedText)} color="primary">
          <SystemLabel languageCode={lang} name="Save" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

function ConfirmDialog(props) {
  const getTypLabel = (type) => {
    switch (type) {
      case 1:
        return "Restore";
      case 2:
        return "SetAnwered";
      case 3:
        return "Archive";
      default:
        return "";
    }
  };
  const { onCancel, onAction, type } = props;

  return (
    <div>
      <Dialog open={true} TransitionComponent={Transition} keepMounted onClose={() => null} aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
        <DialogTitle id="alert-dialog-slide-title">
          {" "}
          <SystemLabel name="AreYouSure" languageCode={props.lang} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <SystemLabel languageCode={props.lang} name={"DoYouWanna" + getTypLabel(type)} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="primary">
            <SystemLabel languageCode={props.lang} name="Close" />
          </Button>
          <Button onClick={onAction} color="primary">
            <SystemLabel languageCode={props.lang} name="Save" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

function MessageBox({ message, timeStamp, name, no, setEdit, activeEdit, toggleVisibility, clientKey, isBlocked, deleted, id, lang, block = () => null }) {
  /*  const [editId, setEditId] = useState(null); */
  const formatTime = (date) => {
    if (datesAreOnSameDay(new Date(date), new Date())) {
      let formattedDate = new Date(date);
      let h = formattedDate.getHours();
      let m = formattedDate.getMinutes();
      if (m < 10) m = "0" + m;
      if (h < 10) h = "0" + h;
      return h + ":" + m;
    } else {
      let formattedDate = new Date(date);
      let d = formattedDate.getUTCDay().toString().substr(0, 3);
      let h = formattedDate.getHours();
      let m = formattedDate.getMinutes();
      if (m < 10) m = "0" + m;
      if (h < 10) h = "0" + h;
      return (
        <React.Fragment>
          {dayConverter(d)} {h + ":" + m}
        </React.Fragment>
      );
    }
  };
  const dayConverter = (d, h, m) => {
    switch (d) {
      case "1":
        return <SystemLabel languageCode={lang} name="Monday" />;
      case "2":
        return <SystemLabel languageCode={lang} name="Tuesday" />;
      case "3":
        return <SystemLabel languageCode={lang} name="Wednesday" />;
      case "4":
        return <SystemLabel languageCode={lang} name="Thursday" />;
      case "5":
        return <SystemLabel languageCode={lang} name="Friday" />;
      case "6":
        return <SystemLabel languageCode={lang} name="Saturday" />;
      case "7":
        return <SystemLabel languageCode={lang} name="Sunday" />;
      default:
        return "";
    }
  };
  const datesAreOnSameDay = (first, second) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
  return (
    <div style={{ width: "100%" }}>
      <Row style={{ width: "100%" }}>
        <Col className={"stage-messages stage-messages--received"} style={{ opacity: isBlocked ? 0.5 : 1 }}>
          <div className={"stage-time-stamp"}>
            {isBlocked ? <BlockIcon style={{ marginRight: 10, color: "#fff" }} /> : null}
            <strong
              style={{
                marginRight: 15,
                color: "#fff",
              }}
            >
              {" "}
            </strong>{" "}
            {name} {formatTime(timeStamp)}
          </div>
        </Col>
      </Row>
      <Row style={{ width: "100%" }}>
        <Col className={"col-8 stage-messages stage-messages--received"} style={{ opacity: deleted ? 0.5 : 1 }}>
          {deleted ? <DeleteIcon style={{ marginRight: 10, color: "#fff" }} /> : null}
          <div className={"stage-message"}>{message.includes("JX_ADMIN_REMOVED:") ? message.replace("JX_ADMIN_REMOVED:", "") : message}</div>
        </Col>
        <Col className="col-4 text-left" style={{ padding: 0 }}>
          <div className="stage-wrap">
            <div onClick={() => setEdit(!activeEdit ? id : null)} className="stage-tools">
              <div style={{ width: "100%" }}>
                <EditIcon />
              </div>
              <div style={{ width: "100%" }}>
                <SystemLabel name="Edit" languageCode={lang} />
              </div>
            </div>
            <div onClick={() => toggleVisibility(id, !deleted)} className="stage-tools">
              <div style={{ width: "100%" }}>{!deleted ? <DeleteIcon /> : <RestoreIcon />}</div>
              <div style={{ width: "100%", minWidth: "50px" }}>
                {!deleted ? <SystemLabel name={"DeleteMessage"} languageCode={lang} /> : null}
                {deleted ? <SystemLabel name={"RestoreMessage"} languageCode={lang} /> : null}
              </div>
            </div>
            {/* {deleted ? (
              <div onClick={() => toggleVisibility(id, false)} className="stage-tools">
                <div style={{ width: "100%" }}>
                  <RestoreIcon />
                </div>
                <div style={{ width: "100%" }}>
                  <SystemLabel name={"RestoreMessage"} languageCode={lang} />
                </div>
              </div>
            ) : null} */}
            {!isBlocked ? (
              <div onClick={() => block(clientKey, true)} className="stage-tools">
                <div style={{ width: "100%" }}>
                  <BlockIcon />
                </div>
                <div style={{ width: "100%" }}>
                  <SystemLabel name="BlockUser" languageCode={lang} />
                </div>
              </div>
            ) : (
              <div onClick={() => block(clientKey, false)} className="stage-tools">
                <div style={{ width: "100%" }}>
                  <RestoreIcon />
                </div>
                <div style={{ width: "100%" }}>
                  <SystemLabel name="RestoreBlock" languageCode={lang} />
                </div>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}
